import anime from 'animejs';
export default class AnimatePhone{
    constructor( element ){
        this.element = document.querySelector(element);
        if(!this.element) return;
        this.graph = document.querySelector('.animate');
        this.rows = Array.from(document.querySelectorAll('#riadky g g')); 
        this.topArrow = document.querySelector('#top-arrow')
        this.bottomArrow = document.querySelector('#bottom-arrow')
        this.yAxis = document.querySelector('#Rectangle_24 rect');
        this.xAxis =document.querySelector('#Rectangle_24_copy rect');
        this.xAxisPerex= document.querySelector('.maximum-value__xAxis')
        this.yAxisPerex= document.querySelector('.maximum-value__yAxis')
        this.bindEvents()
    }
    bindEvents(){
        document.addEventListener('aos:in:animate-graph--phone', ({ detail }) => {
            this.startAnimatingPhoneGraph()
        });
    }
    startAnimatingPhoneGraph(){
        var tl = anime.timeline({
            easing:'easeInOutQuad',
            duration: 1000
            
          });
          tl
          .add({
            targets: [this.topArrow,this.bottomArrow],
            opacity:[0,1]
            })
            .add({
                targets:this.xAxis,
                width:['0%','96%']

            }).add({
                targets:this.yAxis,
                height:['0%','91%']

            },'-=1000')
           
            .add({
              targets:this.rows,
              opacity:[0,1],
              delay:anime.stagger(100)
          })
          
        
    }
}